import React from "react";
import Anonymous from "../Anonymous";
import StaticPageDetails from "../static_pages_admin/StaticPageDetails";

function CommunityRules() {
  return (
    <Anonymous>
      <StaticPageDetails slug="community-rules"></StaticPageDetails>
    </Anonymous>
  );
}

export default CommunityRules;
